import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const institutionProcedureApi = {
    getInstitutionProceduresByInstitutionId: (institutionId: number): Observable<Dtos.GetInstitutionProceduresByInstitutionIdResponse> => {
        //Create the request.
        let request: Dtos.GetInstitutionProceduresByInstitutionId = new Dtos.GetInstitutionProceduresByInstitutionId();
        request.institutionId = institutionId;

        //Send request.
        const response: Promise<Dtos.GetInstitutionProceduresByInstitutionIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getInstitutionProcedureById: (id: number): Observable<Dtos.GetInstitutionProcedureByIdResponse> => {
        //Create the request.
        let request: Dtos.GetInstitutionProcedureById = new Dtos.GetInstitutionProcedureById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetInstitutionProcedureByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setInstitutionProcedure: (institutionProcedure: Dtos.InstitutionProcedure): Observable<Dtos.SetInstitutionProcedureResponse> => {

        let request: Dtos.SetInstitutionProcedure = new Dtos.SetInstitutionProcedure();

        request.institutionProcedure = institutionProcedure;

        // send request
        const response: Promise<Dtos.SetInstitutionProcedureResponse> = client.post(request);

        return Observable.from(response);
    },
    createInstitutionProcedure: (institutionId: number): Observable<Dtos.CreateInstitutionProcedureResponse> => {
        //Create the request.
        let request: Dtos.CreateInstitutionProcedure = new Dtos.CreateInstitutionProcedure();

        request.institutionId = institutionId;

        //Send request.
        const response: Promise<Dtos.CreateInstitutionProcedureResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateInstitutionProcedure: (institutionProcedure: Dtos.InstitutionProcedure): Observable<Dtos.ValidateInstitutionProcedureResponse> => {

        let request: Dtos.ValidateInstitutionProcedure = new Dtos.ValidateInstitutionProcedure();

        request.institutionProcedure = institutionProcedure;

        // send request
        const response: Promise<Dtos.ValidateInstitutionProcedureResponse> = client.post(request);

        return Observable.from(response);
    },
}